import React, { useEffect, useState } from "react";
import { Layout, Row, Col, Typography, BackTop } from "antd";
import {
  FacebookFilled,
  TwitterCircleFilled,
  LinkedinFilled,
  YoutubeFilled,
  UpSquareOutlined,
} from "@ant-design/icons";
import "./Footer.css";
const { Footer: AntFooter } = Layout;
const { Link, Text } = Typography;

const CustomFooter: React.FC = () => {
  const [showBackTop, setShowBackTop] = useState(false);
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollPosition > documentHeight * 0.8) {
        setShowBackTop(true);
      } else {
        setShowBackTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* Top Footer Section */}
      <AntFooter className="top-footer">
        <Row justify="space-between" align="middle">
          <Col>
            <ul className="footer-links">
              <li style={{ fontWeight: "bold" }}>
                Connect with us
              </li>
              <li>
                <Link href="/contactUs">Contact</Link>
              </li>
            </ul>
          </Col>
          <Col>
            <ul className="social-icons">
              <li>
                <Link href="https://www.facebook.com/Chevron" target="_blank">
                  <FacebookFilled style={{ fontSize: "24px", color: "#4267B2" }} />
                </Link>
              </li>
              <li>
                <Link href="http://twitter.com/Chevron" target="_blank">
                  <TwitterCircleFilled style={{ fontSize: "24px", color: "#1DA1F2" }} />
                </Link>
              </li>
              <li>
                <Link href="http://www.linkedin.com/company/chevron" target="_blank">
                  <LinkedinFilled style={{ fontSize: "24px", color: "#0077B5" }} />
                </Link>
              </li>
              <li>
                <Link href="https://www.youtube.com/user/Chevron" target="_blank">
                  <YoutubeFilled style={{ fontSize: "24px", color: "#FF0000" }} />
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
      </AntFooter>

      {/* Bottom Footer Section */}
      <AntFooter className="bottom-footer">
        <Row justify="space-between" align="middle">
          <Col>
            <Text className="footer-text">&copy; {currentYear} Chevron Corporation. All rights reserved.</Text>
          </Col>
          <Col>
            <ul className="footer-links">
              <li>
                <Link href="/siteMap">Site Map</Link>
              </li>
              <li>
                <Link href="https://www.chevron.com/terms-of-use" target="_blank">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link href="http://www.chevron.com/privacystatement" target="_blank">
                  Privacy
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
        {/* Conditionally render BackTop */}
        {showBackTop && (
          <BackTop>
            <div className="back-to-top">
            <UpSquareOutlined />
            </div>
          </BackTop>
        )}
      </AntFooter>
    </>
  );
};

export default CustomFooter;